module.exports = __webpack_public_path__ + "static/img/brees-2001-top-image-thumb.2618330.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2001-top-image-thumb.jpg
// module id = X13F
// module chunks = 1